// tell JSHint not to warn about not using this function
/* exported init_bar */
function init_bar() {
	// tell JSHint about exports
	/* exported headlines, links */
	const headlines = [
		'<a href="https://jkhub.org/page/index.html/_/sitenews/background-contest-2-for-real-this-time-r125">Background Competition</a>',
		'<a href="https://jkhub.org/page/index.html/_/interviews/nlcube-introduction-r124">Interview: #nL.Cube</a>',
		'<a href="https://jkhub.org/page/index.html/_/interviews/interview-with-kualan-r122">Interview: Kualan</a>',
		'<a href="https://jkhub.org/page/index.html/_/sitenews/good-bad-and-ugly-r120">Good, Bad, Ugly</a>'
	];
	
	const links = {
		"Groups": {
			"Social": {
				"Angels of Fire": "http://aof-clan.com/main.html",
				"Dark Jedi Empire": "http://darkjediempire.ucoz.com",
				"-[DE]-": "http://darkempireofthesith.com/",
				"EFF": "http://www.eff-clan.org",
				"Elite Warriors": "http://elitewarriors.net/index.php",
				"JAWA": "https://thejawaclan.com",
				"Knights Reborn": "http://www.knights-reborn.org",
				"oFc": "http://ofc-clan.net",
				"Soul Reapers": "http://soulreapersjk3.enjin.com",
	            "Sith Praxeum": "http://www.sithpraxeum.com"
			 },
			"Hybrid": {
				"Jedi of Freedom": "http://www.jofacademy.eu",
				"Random": "http://randomclan.freeforums.net",
				"Republic Galaxy": "http://republicgalaxy.forumotion.eu",
				"The Exiled Knights": "http://theexiledknights.com"
			},
			"Educational": {
				"Terminative 3": "http://terminative3.netgoo.org"
			},
	
			"Roleplaying": {
				"JA Order": "http://jao.enjin.com/home"
			},
	
			"Non-English": {
				"Saberology": "http://saberologyclan.atw.hu",
				"Akademia na Yavin4": "http://www.yavin4.pl"
			}
		},
		"Mods": {
			"ClanMod": "https://jkhub.org/forum/123-clanmod/",
			"jaMME": "https://jkhub.org/forum/75-jedi-academy-moviemakers-edition/",
			"JA++": "http://japp.jkhub.org",
			"Jedi Betrayal": "http://jedibetrayal.com",
			"JK Galaxies": "https://jkhub.org/forum/117-jedi-knight-galaxies/",
			"Makermod": "https://jkhub.org/forum/111-makermod/",
			"Movie Battles II": "http://moviebattles.org",
			"Opensaber": "http://terminative3.netgoo.org/h2-opensaber-modification"
		},
		"People": {
			"Circa": "http://circa.im",
			"Darth Arth": "http://darth-arth.de",
			"therfiles": "http://therfiles.weebly.com",
	        "mrwonko" : "http://mrwonko.de"
	
		},
		"Resources": {
			"JKH Master Server": "http://my.jacklul.com/jkhubservers/",
			"Mac Modding": "http://redsaurus.net/makingmacmods",
			"Map Forge": "http://map-forge.net",
			"Mapping": "https://jkhub.org/page/mapping.html",
			"OpenJK": "https://jkhub.org/topic/2220-frequently-asked-questions/",
			"Server Hosting": "https://jka.io/",
			"Site Hosting": "https://sitehost.io/"
		}
	};
	// tell JSHint about imports
	/* globals links, headlines */
	const MS_PER_HEADLINE = 5000;
	const MS_PER_HEADLINE_AFTER_CLICK = 10000;
	const _document = document;
	const _window = window;
	const _body = _document.body;
	let curHeadline = 0;
	let newsTimeout = null;
	
	const headline = _document.createElement( "span" );
	
	function show_headline( duration ) {
		duration = duration || MS_PER_HEADLINE;
		headline.innerHTML = headlines[ curHeadline ];
		if( newsTimeout !== null ) {
			_window.clearTimeout( newsTimeout );
		}
		newsTimeout = _window.setTimeout( next_headline, duration );
	}

	function prev_headline( duration ) {
		curHeadline = ( curHeadline - 1 + headlines.length ) % headlines.length;
		show_headline( duration );
	}

	function next_headline( duration ) {
		curHeadline = ( curHeadline + 1 ) % headlines.length;
		show_headline( duration );
	}

	function add_links( parent, children, depth ) {
		for( const key in children ) {
			if( !children.hasOwnProperty( key ) ) {
				continue;
			}
			const child = children[ key ];
			const prefix = depth > 0 ? "&nbsp;&nbsp;" : "";
			const text = prefix + key;
			
			const barmenu = _document.createElement( "li" );
			parent.appendChild( barmenu );
			if( typeof child !== 'object' ) {
				const title = _document.createElement( "a" );
				if( child ) {
					title.href = child;
					title.setAttribute( "target", "_blank" );
				} else {
					title.href = "#";
				}
				title.innerHTML = text;
				barmenu.appendChild( title );
			} else {
				const title = _document.createElement( "a" );
				title.href = "#";
				title.innerHTML = text;
				barmenu.appendChild( title );
			
				const menu = _document.createElement( "ul" );
				if( depth === 0 ) {
					menu.className = "jkhub-menu";
				} else {
					const span = _document.createElement( 'span' );
					span.innerHTML = '&#187;';
					barmenu.appendChild( span );
					menu.className = "jkhub-submenu";
				}
				barmenu.appendChild(menu);
				add_links( menu, child, depth + 1);
			}
		}
	}
	
	const bar = _document.createElement( "div" );
	bar.className = "jkhub-bar";
	{
		const gloss = _document.createElement( "div" );
		gloss.id = "jkhub-gloss";
		bar.appendChild( gloss );
		
		const inner = _document.createElement( "div" );
		inner.id = "jkhub-inner";
		bar.appendChild( inner );
		{
			const logolink = _document.createElement( "a" );
			logolink.id = "jkhub-logo";
			logolink.href = "http://jkhub.org";
			logolink.title = "JKHub";
			logolink.target = "_blank";
			inner.appendChild( logolink );
			{
				const logoimg = _document.createElement( "img" );
				logoimg.src = "https://assets.jkhub.org/bar/barlogo2.png";
				logoimg.width = "24";
				logoimg.height = "24";
				logoimg.alt = "JKHub Logo";
				logolink.appendChild( logoimg );
			}
			headline.id = "jkhub-headline";
			inner.appendChild( headline );
	
			const prevlink = _document.createElement( "a" );
			prevlink.id = "jkhub-prev-headline";
			prevlink.href = "#";
			prevlink.onclick = function() {
				prev_headline( MS_PER_HEADLINE_AFTER_CLICK );
				return false;
			};
			prevlink.title = "Previous Headline";
			prevlink.innerHTML = "&#x25C4;";
			inner.appendChild( prevlink );
			
			const nextlink = _document.createElement( "a" );
			nextlink.id = "jkhub-next-headline";
			nextlink.href = "#";
			nextlink.onclick = function() {
				next_headline( MS_PER_HEADLINE_AFTER_CLICK );
				return false;
			};
			nextlink.title = "Next Headline";
			nextlink.innerHTML = "&#x25BA;";
			inner.appendChild( nextlink );
			
			const categories = _document.createElement( "ul" );
			categories.className = "jkhub-categories";
			inner.appendChild( categories );
			add_links( categories, links, 0 );
		}
	}
	
	const spacer = _document.createElement( "div" );
	spacer.style.height = "28px";
	spacer.className = "bar-spacer";
	
	_body.insertBefore( spacer, _body.firstChild );
	_body.insertBefore( bar, spacer );
	
	show_headline();
}
